import React from 'react';
import { Topbar } from './Topbar';
import { Sidebar } from './Sidebar';




export const AuthenticatedLayout = ({ children }: { children: React.ReactNode }) => {
    return (
        <div className="min-h-screen bg-[#eff1f7]">
            <Topbar />
            <div className='flex w-full'>
                <Sidebar />
                <div className="px-4 pt-5 pb-4 overflow-y-auto scrollbar-hide w-full h-[calc(100vh-86px)]">
                    {children}
                </div>
            </div>
        </div>
    );
};